import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { AutomationResponse } from './automation.model'

export interface State extends EntityState<AutomationResponse> {
  isLoaded: boolean
  isLoading: boolean
  isAdding: boolean
  // Number of create requests the AddAutomation effect still has queued.
  pendingAdds: number
  isUpdating: boolean
}

export const adapter: EntityAdapter<AutomationResponse> = createEntityAdapter<AutomationResponse>({
  selectId: (a: AutomationResponse) => a.pkey,
  sortComparer: (a, b) => b.created - a.created,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  isAdding: false,
  pendingAdds: 0,
  isUpdating: false,
})
